import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';

// Identidade visual compartilhada
import '@tmr/design-system/styles/tokens.css';
import '@tmr/design-system/styles/global.css';
// Login compartilhado
import '@tmr/login-kit/login.css';
// Shared portal sidebar, before this portal's own layers
import '@tmr/portal-kit/sidebar.css';
// Camada isolada deste portal (vence a cascata)
import './styles/overrides.css';
// Estilos do Portal do Administrador (shell + componentes pa-*)
import './portal/styles/portal.css';
// The site design system — the public site's identity (29), this portal's default. Scoped to <html data-ds="site">.
import '@tmr/design-system/themes/site.css';
import '@tmr/login-kit/login-stage.css';
import '@tmr/portal-kit/sidebar-site.css';
import './styles/site.css';

import { QueryClientProvider } from '@tanstack/react-query';
import { TmrClerkProvider } from '@tmr/auth';
import { applyDesignTheme } from '@tmr/design-system';
import App from './App';
import { createQueryClient } from './portal/data/queryClient';

// Before the first render, so the page never paints in one design system and flips to the other.
// The admin runs on the site design system (29); `?ds=classic` or VITE_DESIGN_SYSTEM=classic still
// brings the previous identity back.
applyDesignTheme(import.meta.env.VITE_DESIGN_SYSTEM || 'site');

const rootEl = document.getElementById('root');
if (!rootEl) throw new Error('Elemento #root não encontrado.');

// One cache per application instance — created outside render so a re-render never drops it.
const queryClient = createQueryClient();

createRoot(rootEl).render(
  <StrictMode>
    <TmrClerkProvider>
      <QueryClientProvider client={queryClient}>
        <App />
      </QueryClientProvider>
    </TmrClerkProvider>
  </StrictMode>,
);
